import { UserPermissions } from "Infrastructure/Api/permissions";
import { MarketEditTabs } from "Market/Components/Tabs/Hooks/useMarketEditTabs";
import { MarketsPage } from "Market/Pages";
import { MarketCreatePage } from "Market/Pages/Create";
import { MarketSelectPage } from "Market/Pages/Select";
import { MarketPaths } from "Market/Routes/Routing";
import { EmptyLayout } from "Shared/Components/Layout/Full/EmptyLayout";
import { SessionAuth } from "supertokens-auth-react/recipe/session";
import { PermissionGuard } from "../../Infrastructure/Components/PermissionGuard/index";

export const MarketRoutes = [
	{
		path: MarketPaths.Index.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.MarketModule.read}>
				<MarketsPage />
			</PermissionGuard>
		),
	},
	{
		path: MarketPaths.EditGeneral.route,
		element: (
			<PermissionGuard permission={UserPermissions.MarketModule.update}>
				<MarketsPage currentTab={MarketEditTabs.general} />
			</PermissionGuard>
		),
	},
	{
		path: MarketPaths.EditRegions.route,
		element: (
			<PermissionGuard permission={UserPermissions.MarketModule.update}>
				<MarketsPage currentTab={MarketEditTabs.regions} />
			</PermissionGuard>
		),
	},
	{
		path: MarketPaths.EditEmails.route,
		element: (
			<PermissionGuard permission={UserPermissions.MarketModule.update}>
				<MarketsPage currentTab={MarketEditTabs.emails} />
			</PermissionGuard>
		),
	},
	{
		path: MarketPaths.OrderImport.route,
		element: <MarketsPage currentTab={MarketEditTabs.import} />,
	},
];

export const MarketEmptyLayoutRoutes = [
	{
		path: MarketPaths.Select.route,
		element: (
			<SessionAuth>
				<EmptyLayout>
					<MarketSelectPage />
				</EmptyLayout>
			</SessionAuth>
		),
	},
	{
		path: MarketPaths.Create.route,
		element: (
			<SessionAuth>
				<EmptyLayout>
					<PermissionGuard permission={UserPermissions.MarketModule.create}>
						<MarketCreatePage />
					</PermissionGuard>
				</EmptyLayout>
			</SessionAuth>
		),
	},
];
